import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { useNavigate } from "react-router-dom";
import { fetchCommonPageProps } from "declarations/common";
import { setProgressBarActive } from "reducers/pageReducer";
import {
  GetMoneyRequestsProps,
  GetUserMoneyRequestsProps,
  UpdateMoneyRequestProps,
} from "declarations/requestServices";
import {
  GetMoneyRequests,
  GetUserMoneyRequests,
  UpdateMoneyRequest,
} from "api/services/request";
import { setMoneyRequest, setMoneyRequests } from "reducers/requestReducer";
import { MoneyRequestType } from "types/loadedData";
import { setMoneyRequestReload } from "reducers/reloadReducer";
import { useAsyncOperation } from "./useAsyncOperation";

export default function useRequest() {
  const { execute } = useAsyncOperation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const { moneyRequests } = useSelector((state: RootState) => state.request);
  const { moneyRequestReload } = useSelector(
    (state: RootState) => state.reload
  );

  const getMoneyRequests = async (
    query: GetMoneyRequestsProps,
    { local, more, reload }: fetchCommonPageProps
  ) => {
    if (
      moneyRequests &&
      moneyRequests.length > 0 &&
      !local &&
      !more &&
      !reload &&
      !moneyRequestReload
    )
      return;

    try {
      const response = await execute(() => GetMoneyRequests(query), {
        errorMessage: "Fetching Money Requests Failed",
      });
      const { requests: loadedRequests, message, status } = response;
      if (status !== 200) throw new Error(message);

      let totalRequests = [...loadedRequests];
      if (local) return totalRequests;
      if (more) totalRequests = [...moneyRequests, ...loadedRequests];

      dispatch(setMoneyRequestReload(false));
      dispatch(setMoneyRequests(totalRequests));
    } catch (error) {}
  };

  const getUserMoneyRequests = async (
    query: GetUserMoneyRequestsProps
  ): Promise<MoneyRequestType[]> => {
    try {
      const response = await execute(() => GetUserMoneyRequests(query), {
        errorMessage: "Fetching User Money Requests Failed",
      });
      const { requests, message, status } = response;
      if (status !== 200) throw new Error(message);
      return requests;
    } catch (error) {
      return [];
    }
  };

  const updateMoneyRequest = async (query: UpdateMoneyRequestProps) => {
    try {
      await execute(() => UpdateMoneyRequest(query), {
        successMessage: "Money Request Updated Successfully",
        errorMessage: "Updating Money Request Failed",

        onSuccess: (response) => {
          const { request, message, status } = response;
          if (status !== 200) throw new Error(message);

          dispatch(setMoneyRequestReload(true));
          dispatch(setMoneyRequest(null));
        },
      });
    } catch (error) {}
  };

  return {
    getMoneyRequests,
    getUserMoneyRequests,
    updateMoneyRequest,
  };
}
